import $ from "jquery";
import Rails from "@rails/ujs"
import {Turbo} from "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import I18n from '../components/i18n-js/index.js.erb'

// https://stackoverflow.com/questions/37738732/jquery-3-0-url-indexof-error
// jquery 3.x call load function different. This is fallback for legacy code to working
jQuery.fn.load = function(callback){ $(window).on("load", callback) };
window.jQuery = jQuery;
window.$ = $;

const cache = {};

function importAll(r) {
    r.keys().forEach((key) => (cache[key] = r(key)));
}

import "../components/context_helps"
import "../components/init.js"
import "../components/jquery.dateFormat"
import "../components/jquery.ddslick-min"
import "../components/json2"
import MathExt from "../components/math.js"
import "../components/stickers_buy"
import "../components/setup_twilio"

importAll(require.context('../components/behavior/', true, /\.js/));
import LocationAutocompletes from '../components/behavior/location_autocompletes'
import OwnersAutocomplete from '../components/behavior/owners_autocomplete'
import {SiteVisitProblemReports} from '../components/behavior/site_visit_problem_reports'

import AccessHubsController from "../components/controllers/access_hubs_controller.js.coffee"
import AccessHubVerificationController from "../components/controllers/access_hub_verification_controller.js.coffee"
import BrainTreeController from "../components/controllers/brain_tree_controller.js"
import CardsController from "../components/controllers/cards_controller.js"
import ClustersController from "../components/controllers/clusters_controller.js"
import "../components/controllers/firmwares_controller.js"
import GroupFacilityAuthorizationController from "../components/controllers/group_facility_authorization_controller.js"
import IdsController from "../components/controllers/ids_controller.js"
import K2GroupFacilityAuthorization from '../components/controllers/k2_group_facility_authorization_controller.js'
import LatchesController from "../components/controllers/latches_controller.js"
import LocationsController from "../components/controllers/locations_controller.js"
import OnlineAccountController from "../components/controllers/online_account_controller.js"
import PeopleController from "../components/controllers/people_controller.js"
import SpacesController from "../components/controllers/spaces_controller.js"
import TroubleTicketsController from "../components/controllers/trouble_tickers_controller.js.coffee.erb"
import UiNodesController from "../components/controllers/ui_nodes_controller.js"
import AnsweringServiceController from "../components/controllers/answering_service_controller.js"
import UiNodePowerConfigurationsController from "../components/controllers/ui_node_power_configurations_controller.js"

importAll(require.context('../components/lib/', true, /\.js/));
importAll(require.context('../components/sections/', true, /\.js/));
importAll(require.context('../components/webrtc/', true, /\.js/));

import PhoneOperator from "../components/sections/group_facility_authorization/phone_operator"
import PlotlyGraph from "../components/sections/reports/plotly_graph.js"

import 'bootstrap/dist/js/bootstrap'
import 'flatpickr'
import 'controllers' // Stimulus controllers

require('underscore')
require('leaflet')
require('jquery-datetimepicker')
require('jquery-chained/jquery.chained')
require("jquery-ui")
require('datatables.net')
require('datatables.net-dt')
require('datatables.net-jqui')
require('datatables.net-bs')
require('datatables.net-buttons-bs')
require('datatables.net-buttons')
require('datatables.net-buttons/js/buttons.colVis.js')
require('datatables.net-buttons/js/buttons.html5.js')
require('jstree')
require('select2')
require('jquery-colorbox')
require('backbone')
require('select2/dist/css/select2.css')
require("stylesheets/application.scss")

Turbo.session.drive = false // make Turbo Drive opt-in - you need to use data-turbo="true" per-element
Rails.start()
ActiveStorage.start()

window.addEventListener('DOMContentLoaded', () => {
    $('.js-states').select2()
})
console.log(I18n.t('views.cards.types.bikelink_app'))

MathExt.round_to(10.5, 2)
window.I18n = I18n
window.PhoneOperator = PhoneOperator
window.BrainTreeController = BrainTreeController
window.OnlineAccountController = OnlineAccountController
window.GroupFacilityAuthorizationController = GroupFacilityAuthorizationController
window.UiNodePowerConfigurationsController = UiNodePowerConfigurationsController
window.PlotlyGraph = PlotlyGraph
window.IdsController = IdsController
window.CardsController = CardsController
window.PeopleController = PeopleController
window.UiNodesController = UiNodesController
window.LocationAutocompletes = LocationAutocompletes
window.OwnersAutocomplete = OwnersAutocomplete
window.K2GroupFacilityAuthorization = K2GroupFacilityAuthorization
window.AccessHubVerificationController = AccessHubVerificationController
window.AccessHubsController = AccessHubsController
window.AnsweringServiceController = AnsweringServiceController

window.JST = {};
window.JST['templates/map/row'] = require("!!ejs-compiled-loader?{}!../templates/map/marker_popup.jst.ejs")

new SiteVisitProblemReports()
new AnsweringServiceController()
